import { callDecimal, DecimalResult } from "../utils.ts";
import {
  Favorite,
  ManageAssetWithFavorite,
  ManageAssetWithLicense,
} from "../common-types/manageAssets.ts";

// a favorite doesn't necessarily have a licence
export type FavoritedAsset = ManageAssetWithFavorite | ManageAssetWithLicense;

export function getFavorites(): Promise<DecimalResult<FavoritedAsset[]>> {
  return callDecimal<FavoritedAsset[]>("/api/v1/users/favorites", {
    method: "GET",
  });
}

// WARNING: Possibly missing favoritedAt. Being fixed in VST-81992
export type FavoritesByVbid = Record<string, Favorite>;

export function getFavoritesByVbid(
  vbids: string[]
): Promise<DecimalResult<FavoritesByVbid>> {
  const vals = vbids.map((vbid) => "vbids[]=" + vbid).join("&");
  return callDecimal<FavoritesByVbid>(`/api/v1/users/favorites/for?${vals}`, {
    method: "GET",
  });
}

export function addFavorite(vbid: string): Promise<DecimalResult<unknown>> {
  return callDecimal<unknown>("/api/v1/users/favorites", {
    method: "POST",
    body: JSON.stringify({
      vbid,
    }),
  });
}

export function removeFavorite(vbid: string): Promise<DecimalResult<unknown>> {
  return callDecimal<unknown>(`/api/v1/users/favorites/${vbid}`, {
    method: "DELETE",
  });
}
